import { useEffect, useState } from "react";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const useMarketPlaceVerificationStatus = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null);
  
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    const fetchStatus = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/marketplace/verification-status`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        const data = await res.json();

        setIsVerified(!!data?.is_verified);
        setVerificationStatus(data?.verification_type || null);
      } catch (err) {
        console.error(err);
      }
    };

    fetchStatus();
  }, []);

  return {
    isVerified,
    verificationStatus,
  };
};

export default useMarketPlaceVerificationStatus;